import { Typography } from '@mui/material';
import { TypographyProps } from '@mui/material';

export function CaptionLabel({ children, ...rest }: TypographyProps) {
    return (
        <Typography variant='caption' fontSize={'0.85rem'} {...rest}>
            {children}
        </Typography>
    );
}
